/**
 * useClasses
 * The custom hook which provided to external use via context
 */

import {useContext} from 'react'
import ClassesContext from './classes-context'

const useClasses = () => {
  const context = useContext(ClassesContext)
  return context
}

export default useClasses
